import React from 'react';
import Toolbar from '@mui/material/Toolbar';
import { List, Edit, Create, Show, SimpleShowLayout, Datagrid, TextField, ImageField, EmailField, SimpleForm, TextInput, FileField, FileInput, Filter, SelectInput, BooleanField, ShowButton, CreateButton, Tab, TabbedShowLayout, FunctionField } from 'react-admin';
import { SOCIAL_TYPES, USER_TYPES } from '../constants';
import { formatDateTime } from '../utils/timeFormat';
import VideoHistoryTab from './userTabs/VideoHistoryTab';
import SubscriptionHistoryTab from './userTabs/SubscriptionHistoryTab';
import SubscriptionsTab from './userTabs/SubscriptionsTab';
import DevicesTab from './userTabs/DevicesTab';
import NotificationsTab from './userTabs/NotificationsTab';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Tooltip } from '@mui/material';

const TextFilter = (props) => (
  <Filter {...props}>
    <TextInput label="firstName" source="firstName" />
    <TextInput label="lastName" source="lastName" />
    <TextInput label="Email" source="email" />
    <TextInput label="Phone Number" source="phoneNumber" />
  </Filter>
);

const UserAction = props => {
  const {
    filters,
    showFilter,
    resource,
    displayedFilters,
    filterValues,
    basePath,
  } = props

  return (
    <Toolbar>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      <CreateButton basePath={basePath} />
    </Toolbar>
  );
};

export const UserList = props => (
  <List {...props} filters={<TextFilter/>} actions={<UserAction props={props} />}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="firstName" />
      <TextField source="lastName" />
      <EmailField source="email" />
      <TextField source="phoneNumber" />
      <TextField source="social" />
      <ShowButton />
    </Datagrid>
  </List>
);

export const UserShow = props => (
  <Show {...props}>
    <TabbedShowLayout>
      <Tab label="Ерөнхий мэдээлэл" path="">
        <SimpleShowLayout>
          <TextField source="id" label="ID" />
          <TextField source="firstName" label="Нэр" />
          <TextField source="lastName" label="Овог" />
          <EmailField source="email" label="И-мэйл" />
          <TextField source="phoneNumber" label="Утасны дугаар" />
          <ImageField source="picture" label="Зураг" />
          <FunctionField 
            label="Сүүлд нэвтэрсэн огноо" 
            render={record => formatDateTime(record.lastLogin)} 
          />
          <TextField source="social" label="Social network" />
          <BooleanField source="isDeleted" label="Аккаунт устгагдсан эсэх" />
          <FunctionField 
            label="Үүсгэсэн огноо" 
            render={record => formatDateTime(record.createdAt)} 
          />
          <FunctionField 
            label="Шинэчилсэн огноо" 
            render={record => formatDateTime(record.updatedAt)} 
          />
          <TextField source="type" label="Хэрэглэгчийн төрөл" />
        </SimpleShowLayout>
      </Tab>
      
      <Tab label="Төлбөрийн мэдээлэл">
        <SubscriptionsTab {...props} />
      </Tab>

      <Tab label="Видео үзэлт" path="watch-history">
        <VideoHistoryTab {...props} />
      </Tab>

      <Tab label="Subscription түүх" path="subscription-history">
        <SubscriptionHistoryTab {...props} />
      </Tab>

      <Tab label="Төхөөрөмжүүд" path="devices">
        <DevicesTab {...props} />
      </Tab>

      <Tab 
        label={
          <Tooltip title="Мэдэгдлүүд" placement="top">
            <NotificationsIcon />
          </Tooltip>
        } 
        path="notifications"
      >
        <NotificationsTab {...props} />
      </Tab>
    </TabbedShowLayout>
  </Show>
);

export const UserEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="id" />
      <TextInput source="firstName" />
      <TextInput source="lastName" />
      <TextInput source="phoneNumber" />
      <TextInput source="email" />
      <ImageField source="picture" title="Зураг" />
      <FileInput source="file" label="Зураг" accept="image/*">
        <FileField source="image" title="image" />
      </FileInput>
      <SelectInput label="Нэвтэрсэн Сошиал хаяг" source="social" choices={SOCIAL_TYPES} />
      <SelectInput label="Төрөл" source="type" choices={USER_TYPES} />
    </SimpleForm>
  </Edit>
);

export const UserCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="firstName" />
      <TextInput source="lastName" />
      <TextInput source="phoneNumber" />
      <TextInput source="email" />
      <FileInput source="file" label="Зураг" accept="image/*">
        <FileField source="image" title="image" />
      </FileInput>
      <TextInput source="social" defaultValue="MANUAL" disabled={true}/>
    </SimpleForm>
  </Create>
);